import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DateTimePicker = ({
  label,
  selected,
  onChange,
  showTime = false,
  placeholder = "Select date",
  minDate,
  maxDate,
  showMonthYearDropdown = true,
  yearDropdownItemNumber = 100,
  scrollableYearDropdown = true,
}) => {
  return (
    <div className="mb-4">
      {label && (
        <label className="block mb-1 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}
      <DatePicker
        selected={selected}
        onChange={onChange}
        showTimeSelect={showTime}
        dateFormat={showTime ? "yyyy-MM-dd HH:mm" : "yyyy-MM-dd"}
        className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:ring focus:ring-blue-200 focus:outline-none"
        placeholderText={placeholder}
        minDate={minDate}
        maxDate={maxDate}
        showMonthDropdown={showMonthYearDropdown}
        showYearDropdown={showMonthYearDropdown}
        dropdownMode="select"
        yearDropdownItemNumber={yearDropdownItemNumber}
        scrollableYearDropdown={scrollableYearDropdown}
      />
    </div>
  );
};

export default DateTimePicker;
